import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Сбрасывает прокрутку при смене маршрута.
 * Контент скроллится внутри .content-wrap, а не в window.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.querySelector('.content-wrap')?.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
